import React from 'react';
import { IconBase } from '../Base';
export const IconUAH = (props) => (React.createElement(IconBase, { ...props, viewportSize: 24 },
    React.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#FFDA44" }),
    React.createElement("path", { d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12", fill: "#338AF3" }),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_2_9278" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
//# sourceMappingURL=UAH.js.map